/* eslint-disable */
import React, { useState, useEffect, useContext } from 'react';
import {
  Box, Typography, Drawer, IconButton, CircularProgress, Skeleton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useHistory, useLocation } from 'react-router-dom';
import useNetworkLoader from 'hooks/useNetworkLoader';
import Image from 'Shared/Image';
import AppButton from 'Shared/UI/Button';
import ConfigContext from 'Shared/ConfigContext';
import {
  setOpenPanierList,
} from 'Shared/ConfigContext/Actions';
import { formatAmount, getStocks } from 'Utils/ulilities';
import { getEquivalentsProduct, getProductsData } from './CatalogServices';
import { applyRemise } from './Available';
import AddPanierModal from './popup';
import noImage from '../../Images/no_image.svg';
import addToCartIcon from '../../Images/addtocart.svg';

const InfoRow = ({ label, value, valueColor }) => (
  <Box sx={{ display: 'flex', borderBottom: '1px solid #F0F2F5', py: '10px', px: '14px' }}>
    <Typography sx={{ flex: 1, fontSize: '12px', color: '#8397AE', fontWeight: 400 }}>{label}</Typography>
    <Typography sx={{ flex: 1, fontSize: '12px', color: valueColor || '#1A2035', fontWeight: 500 }}>{value}</Typography>
  </Box>
);

const ProductDetailDrawer = () => {
  const history = useHistory();
  const location = useLocation();
  const [product, setProduct] = useState(location.state?.product || null);
  const [loading, setLoading] = useState(!location.state?.product);
  const [equivalents, setEquivalents] = useState([]);
  const [equivalentsLoading, setEquivalentsLoading] = useState(false);
  const [activeImage, setActiveImage] = useState(null);
  const { callApi } = useNetworkLoader();
  const { dispatch, state: { paniers } } = useContext(ConfigContext);

  const reference = location.pathname.startsWith('/products/')
    ? location.pathname.split('/products/')[1]
    : undefined;

  useEffect(() => {
    if (!reference) return;
    setEquivalents([]);
    setActiveImage(null);
    setEquivalentsLoading(true);

    const fetchEquivalents = (localId) => {
      callApi(
        () => getEquivalentsProduct(localId),
        (eqData) => {
          setEquivalents(Array.isArray(eqData) ? eqData : (eqData?.content || []));
          setEquivalentsLoading(false);
        },
        false,
        () => setEquivalentsLoading(false),
      );
    };

    const loadProduct = (found) => {
      setProduct(found);
      setLoading(false);
      setActiveImage(null);
      if (!found?.reference) return;
      if (found.origin) {
        callApi(
          () => getProductsData('page=0&size=1', { references: [found.reference] }),
          (data) => {
            const localId = data?.content?.[0]?.id;
            if (localId) fetchEquivalents(localId);
            else setEquivalentsLoading(false);
          },
          false,
          () => setEquivalentsLoading(false),
        );
      } else if (found?.id) {
        fetchEquivalents(found.id);
      }
    };

    if (location.state?.product && location.state.product.reference === reference) {
      loadProduct(location.state.product);
      return;
    }

    setLoading(true);
    setProduct(null);
    callApi(
      () => getProductsData('page=0&size=1', { references: [reference] }),
      (data) => loadProduct(data?.content?.[0] || null),
      false,
    );
  }, [reference]);

  const handleClose = () => {
    if (history.length > 1) history.goBack();
    else history.push('/catalog');
  };

  const handleAddToCart = () => {
    if (!product) return;
    dispatch(setOpenPanierList(true, product));
  };

  const goToEquivalent = (eq) => {
    history.replace(`/products/${eq.reference}`, { product: eq, background: location.state?.background });
  };

  const hasPrice = product?.price > 0;
  const discountPct = hasPrice ? applyRemise(product?.remise, product?.remiseExceptionnelle) : 0;
  const isPromotion = hasPrice && Boolean(product?.remiseExceptionnelle);
  const netPrice = isPromotion
    ? Number((product.price * (100 - discountPct)) / 100)
    : product?.price;

  const { stockBouskoura, stockAinSebaa, stockDerbOmar, stockCfcim, reserved, reservedDO } = product || {};
  const { stockDisponibleBouskoura, stockDisponibleDebOmar } = getStocks(
    stockDerbOmar, reservedDO, stockBouskoura, stockAinSebaa, stockCfcim, reserved,
  );
  const isAvailable = stockDisponibleBouskoura > 0 || stockDisponibleDebOmar > 0;

  const allImages = product?.images?.length
    ? product.images.map((img) => img.downloadUrl)
    : product?.image
      ? [product.image]
      : [];
  const displayImage = activeImage || allImages[0] || noImage;

  return (
    <>
      <AddPanierModal />
      <Drawer
        anchor="right"
        open
        onClose={handleClose}
        PaperProps={{
          sx: {
            width: { xs: '100%', sm: 500 },
            boxShadow: '-4px 0 32px rgba(0,0,0,0.12)',
            overflowX: 'hidden',
          },
        }}
        ModalProps={{ keepMounted: false }}
      >
        {/* Header */}
        <Box sx={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          px: '20px', py: '14px', borderBottom: '1px solid #EDF2F7',
        }}>
          <Typography sx={{ fontSize: '16px', fontWeight: 600, color: '#717182', fontFamily: 'Open Sans, sans-serif' }}>Détail produit</Typography>
          <IconButton onClick={handleClose} size="small">
            <CloseIcon sx={{ fontSize: 20, color: '#8397AE' }} />
          </IconButton>
        </Box>

        {/* Body */}
        {loading ? (
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flex: 1, height: '300px' }}>
            <CircularProgress />
          </Box>
        ) : !product ? (
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flex: 1, height: '300px' }}>
            <Typography sx={{ fontSize: '14px', color: '#8397AE' }}>Produit introuvable.</Typography>
          </Box>
        ) : (
          <Box sx={{ overflowY: 'auto', flex: 1 }}>

            {/* Image area */}
            <Box sx={{ p: '16px', display: 'flex', gap: '10px', height: 240 }}>
              {/* Main image */}
              <Box sx={{
                flex: 1, border: '1px solid #EDF2F7', borderRadius: '10px',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                position: 'relative', backgroundColor: '#FFFFFF', overflow: 'hidden',
              }}>
                {hasPrice && discountPct > 0 && (
                  <Box sx={{
                    position: 'absolute', top: 8, left: 8, zIndex: 1,
                    backgroundColor: '#DEFAF3', color: '#0AD69F',
                    borderRadius: '10px', px: '8px', py: '3px',
                    fontSize: '11px', fontWeight: 800,
                  }}>
                    -{discountPct}%
                  </Box>
                )}
                <Image
                  src={displayImage}
                  alt={product.name}
                  style={{ maxHeight: 200, maxWidth: '100%', objectFit: 'contain' }}
                />
                {product?.brand?.logoImage && (
                  <Box sx={{ position: 'absolute', bottom: 8, right: 10, overflow: 'hidden', maxWidth: '40%' }}>
                    <Image src={product.brand.logoImage} alt={product.brand.name} style={{ height: 28, width: 'auto', display: 'block' }} />
                  </Box>
                )}
              </Box>

              {/* Thumbnails */}
              {allImages.length > 1 && (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: '6px', width: 56, maxHeight: 240, overflowY: 'auto', scrollbarWidth: 'none', '&::-webkit-scrollbar': { display: 'none' } }}>
                  {allImages.map((img, i) => (
                    <Box
                      key={i}
                      onClick={() => setActiveImage(img)}
                      sx={{
                        flexShrink: 0, width: 56, height: 52, border: `1.5px solid ${displayImage === img ? '#2557A7' : '#EDF2F7'}`,
                        borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center',
                        cursor: 'pointer', backgroundColor: '#FAFBFC', overflow: 'hidden',
                        '&:hover': { borderColor: '#2557A7' },
                      }}
                    >
                      <Image src={img} alt="" style={{ maxHeight: 40, maxWidth: 48, objectFit: 'contain' }} />
                    </Box>
                  ))}
                </Box>
              )}
            </Box>

            {/* Product info */}
            <Box sx={{ px: '20px', pb: '12px' }}>
              {/* Brand name */}
              {product.brand?.name && (
                <Typography sx={{ fontSize: '13px', fontWeight: 700, color: '#385576', textTransform: 'uppercase', fontFamily: 'Open Sans, sans-serif', mb: '4px' }}>
                  {product.brand.name}
                </Typography>
              )}

              {/* Name */}
              <Typography sx={{ fontSize: '18px', fontWeight: 600, color: '#000000', fontFamily: 'Open Sans, sans-serif', textTransform: 'capitalize', lineHeight: 1.3, mb: '8px' }}>
                {product.name}
              </Typography>

              {/* Price */}
              {hasPrice && (
                <Box sx={{ mb: '14px' }}>
                  <Box sx={{ display: 'flex', alignItems: 'baseline', gap: '3px' }}>
                    <Typography sx={{ fontSize: '28px', fontWeight: 700, color: '#007BC6', fontFamily: 'Open Sans, sans-serif', lineHeight: 1 }}>
                      {formatAmount(netPrice, 2)}
                    </Typography>
                    <Typography sx={{ fontSize: '18px', fontWeight: 700, color: '#007BC6', fontFamily: 'Open Sans, sans-serif', lineHeight: 1 }}>
                      Dh
                    </Typography>
                  </Box>
                  {isPromotion && (
                    <Typography sx={{ fontSize: '14px', fontWeight: 700, color: '#717182', textDecoration: 'line-through', fontFamily: 'Open Sans, sans-serif', mt: '2px' }}>
                      {formatAmount(product.price)} Dh
                    </Typography>
                  )}
                </Box>
              )}
            </Box>

            {/* Info grid */}
            <Box sx={{ mx: '20px', mb: '16px', border: '1px solid #EDF2F7', borderRadius: '10px', overflow: 'hidden', '& > div:nth-of-type(even)': { backgroundColor: '#F8FAFC' } }}>
              <InfoRow label="Référence" value={product.reference} valueColor="#007BC6" />
              {product.brand?.name && <InfoRow label="Marque" value={product.brand.name} />}
              {product.family?.name && <InfoRow label="Famille" value={product.family.name} />}
              {hasPrice && <InfoRow label="Prix brut TTC (avant remise)" value={`${formatAmount(product.price)} Dh`} />}
              {hasPrice && discountPct > 0 && <InfoRow label="Remise appliquée" value={`-${discountPct}%`} valueColor="#0AD69F" />}
              {hasPrice && (
                <InfoRow
                  label="Disponible"
                  value={isAvailable ? 'OUI' : 'NON'}
                  valueColor={isAvailable ? '#0AD69F' : '#EA2027'}
                />
              )}
            </Box>

            {/* Add to cart */}
            {hasPrice && (
              <Box sx={{ px: '20px', mb: '20px' }}>
                <AppButton
                  variant="custom"
                  label="Ajouter au panier"
                  fullWidth
                  icon={<Box component="img" src={addToCartIcon} sx={{ width: 18, height: 18, objectFit: 'contain' }} />}
                  color="#007BC6"
                  hoverColor="#005F9E"
                  onClick={handleAddToCart}
                  sx={{ height: '44px', fontSize: '14px', fontWeight: 400, borderRadius: '10px' }}
                />
              </Box>
            )}

            {/* Tab switcher */}
            <Box sx={{ px: '20px', pt: '16px', pb: '4px' }}>
              <Box sx={{
                backgroundColor: 'rgba(209, 213, 220, 0.45)',
                borderRadius: '12px',
                height: '64px',
                display: 'flex',
                alignItems: 'center',
                px: '8px',
              }}>
                <Box sx={{
                  backgroundColor: '#FFFFFF',
                  border: '1px solid #E6E7EA',
                  boxShadow: '0px 5px 10px rgba(98,107,125,0.07)',
                  borderRadius: '8px',
                  height: '48px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  px: '24px',
                  cursor: 'default',
                }}>
                  <Typography sx={{
                    fontSize: '12px',
                    fontWeight: 700,
                    fontFamily: 'Open Sans, sans-serif',
                    color: '#385576',
                    textTransform: 'uppercase',
                    letterSpacing: '0px',
                  }}>
                    Équivalents
                  </Typography>
                </Box>
              </Box>
            </Box>

              <Box sx={{ px: '20px', py: '16px' }}>
                  {equivalentsLoading ? (
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                      {[...Array(3)].map((_, i) => (
                        <Box key={i} sx={{ display: 'flex', alignItems: 'center', gap: '12px', border: '1px solid #EDF2F7', borderRadius: '10px', p: '10px' }}>
                          <Skeleton variant="rectangular" width={52} height={52} sx={{ borderRadius: '8px', flexShrink: 0 }} />
                          <Box sx={{ flex: 1 }}>
                            <Skeleton variant="text" width="40%" height={14} />
                            <Skeleton variant="text" width="80%" height={14} />
                          </Box>
                          <Skeleton variant="text" width={60} height={20} />
                        </Box>
                      ))}
                    </Box>
                  ) : equivalents.length === 0 ? (
                    <Typography sx={{ fontSize: '13px', color: '#A0AEC0', textAlign: 'center', py: '20px' }}>
                      Aucun produit équivalent
                    </Typography>
                  ) : (
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                      {equivalents.map((eq) => {
                        const eqDiscount = applyRemise(eq.remise, eq.remiseExceptionnelle);
                        const eqIsPromotion = Boolean(eq.remiseExceptionnelle);
                        const eqNet = eqIsPromotion ? Number((eq.price * (100 - eqDiscount)) / 100) : eq.price;
                        return (
                          <Box
                            key={eq.reference || eq.id}
                            onClick={() => goToEquivalent(eq)}
                            sx={{
                              display: 'flex', alignItems: 'center', gap: '12px',
                              border: '1px solid #EDF2F7', borderRadius: '10px', p: '10px',
                              cursor: 'pointer',
                              '&:hover': { borderColor: '#2557A7', backgroundColor: '#F7FAFF' },
                            }}
                          >
                            <Box sx={{
                              width: 52, height: 52, flexShrink: 0, border: '1px solid #EDF2F7',
                              borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center',
                              backgroundColor: '#FFFFFF',
                            }}>
                              <img
                                src={eq.image || noImage}
                                alt={eq.name}
                                style={{ maxHeight: 42, maxWidth: 42, objectFit: 'contain' }}
                                onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = noImage; }}
                              />
                            </Box>
                            <Box sx={{ flex: 1, minWidth: 0 }}>
                              <Typography sx={{ fontSize: '11px', fontWeight: 700, color: '#2557A7' }}>
                                {eq.reference} · <Box component="span" sx={{ color: '#385576' }}>{eq.brand?.name}</Box>
                              </Typography>
                              <Typography sx={{
                                fontSize: '12px', fontWeight: 600, color: '#1A2035',
                                overflow: 'hidden', display: '-webkit-box',
                                WebkitLineClamp: 2, WebkitBoxOrient: 'vertical',
                              }}>
                                {eq.name}
                              </Typography>
                            </Box>
                            {eq.price > 0 && (
                              <Box sx={{ textAlign: 'right', flexShrink: 0 }}>
                                <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#007BC6' }}>
                                  {formatAmount(eqNet, 2)} Dh
                                </Typography>
                                {eqIsPromotion && (
                                  <Typography sx={{ fontSize: '13px', fontWeight: 700, color: '#717182', textDecoration: 'line-through' }}>
                                    {formatAmount(eq.price)} Dh
                                  </Typography>
                                )}
                              </Box>
                            )}
                          </Box>
                        );
                      })}
                    </Box>
                  )}
                </Box>
          </Box>
        )}
      </Drawer>
    </>
  );
};

export default ProductDetailDrawer;
